import React from 'react';
import { Route,withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const privateRouteWithLayout = props => {
  const { layout: Layout, component: Component, ...rest } = props;
  const token = localStorage.getItem('token');
  if (token) { 

  }else{
    props.history.push("/login");
  }
  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

privateRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default  withRouter(privateRouteWithLayout);
